import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCart } from "../context/CartContext";
import "../styles/OrderSuccess.css";

export default function OrderSuccess() {
  const { t } = useTranslation();
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  const goToOrders = () => {
    window.location.replace("/orders");
  };

  const continueShopping = () => {
    window.location.replace("/shop");
  };

  return (
    <main className="order-success-page">
      <section className="order-success-container">
        <div className="order-success-icon">✓</div>

        <h1>{t("orderSuccess.title")}</h1>

        <p>{t("orderSuccess.message")}</p>

        <div className="order-success-actions">
          <button
            type="button"
            onClick={goToOrders}
          >
            {t("orderSuccess.viewOrders")}
          </button>

          <button
            type="button"
            className="order-success-secondary"
            onClick={continueShopping}
          >
            {t("orderSuccess.continueShopping")}
          </button>
        </div>
      </section>
    </main>
  );
}